export const navigation = {
  navigation: {
    dashboard: "仪表板",
    profile: "个人资料",
    signOut: "退出",
    upgradeRequired: "需要升级",
    basicSubscriptionRequired: "需要基本订阅",
    premiumSubscriptionRequired: "需要高级订阅",
  }
};